
/**
 * Compare strings a and b for equality. If either of a or b is null, then the
 * result is false, i.e. null != null. This behavior is appropriate for
 * strictly matching explicit strings where either side of the relation might
 * be undefined and should not match in the case where both sides of the
 * relation are undefined.
 */
export const streq = (a: string | null, b: string | null) => {
    if(a == null || b == null) {
        return false;
    }
    else if(a.length == b.length) {
        return a.toLowerCase() == b.toLowerCase();
    }
    return false;
}
